import UFunction from "./UFunction.mts";

namespace UPromise {
  export type Maybe<T> = T | Promise<T>;
  export type Awaitable<T> = T | PromiseLike<Awaitable<T>>;

  export const delay = (ms: number) =>
    new Promise<void>((resolve) => setTimeout(resolve, ms));

  export const deferrable = <T,>(promise: Promise<T>) =>
    new Promise<T>((resolve) => {
      promise.then((value) => {
        resolve(value);
      });
    });

  export const forever = new Promise(UFunction.noop);
}

export default UPromise;
